import { render, staticRenderFns } from "./AdminUpdate.vue?vue&type=template&id=5ad62c1d&"
import script from "./AdminUpdate.vue?vue&type=script&lang=js&"
export * from "./AdminUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports